import React from "react";
import { InputErrorLabelProps } from "./Input.types";
import { Label } from "@fourkites/elemental-atoms";

const InputErrorLabel = ({
  errorLabel,
  invalid,
  id,
}: InputErrorLabelProps): React.ReactElement<InputErrorLabelProps> => {
  if (errorLabel && invalid) {
    const className = "elemental-Input-errorLabel";
    const size = "medium";

    return typeof errorLabel === "string" ? (
      <Label id={id} size={size} className={className}>
        {errorLabel}
      </Label>
    ) : (
      React.cloneElement(errorLabel, { size, className, id })
    );
  } else {
    return null;
  }
};

export default InputErrorLabel;
